module.exports = __webpack_public_path__ + "img/malaysia.64836e0f.svg";